<template>
  <Content id="inspectOrder">
    <div slot="search">
      <Form :label-width="45" :model="search" id="searchForm">
        <Row>
          <Col><FormItem label="条形码" :label-width="60"><el-input v-model="search.barCode" :maxlength="13" :clearable="true" @input="toInt()"/></FormItem></Col>
          <Col><FormItem label="姓名"><el-input v-model="search.name" :maxlength="50" :clearable="true"/></FormItem></Col>
          <Col><FormItem label="证件号码" :label-width="75"><el-input v-model="search.idCard" :maxlength="18" :clearable="true" style="width: 100%;"/></FormItem></Col>
          <Col>
            <FormItem label="体检任务" :label-width="75">
              <el-select v-model.trim="search.taskId" placeholder="体检任务"
                         clearable filterable size="small" transfer="true" :popper-append-to-body="false" style="min-width: 350px;">
                <el-option v-for="item in taskList" :key="item.value" :label="item.label" :value="item.value" style="min-width: 350px;"/>
              </el-select>
            </FormItem>
          </Col>
          <Col span="5">
            <FormItem  label="学校">
              <el-select v-model.trim="search.schoolId" placeholder="学校名称"
                         clearable filterable size="small" transfer="true" :popper-append-to-body="false" style="width: 100%;" @change="changeSchool">
                <el-option v-for="item in schoolsList" :key="item.value" :label="item.label" :value="item.value" style="width: 100%;"/>
              </el-select>
            </FormItem>
          </Col>
          <Col>
            <FormItem  label="年级">
              <el-select v-model.trim="search.gradeId" placeholder="年级"
                         clearable filterable size="small" transfer="true" :popper-append-to-body="false" style="width: 100%;" @change="changeGrade">
                <el-option v-for="item in gradeList" :key="item.id" :label="item.name" :value="item.id" style="width: 100%;"/>
              </el-select>
            </FormItem>
          </Col>
          <Col>
            <FormItem  label="班级">
              <el-select v-model.trim="search.classesId" placeholder="班级"
                         clearable filterable size="small" transfer="true" style="width: 100%;" :popper-append-to-body="false">
                <el-option v-for="item in classesList" :key="item.id" :label="item.name" :value="item.id" style="width: 100%;"/>
              </el-select>
            </FormItem>
          </Col>
          <!--
          <Col>
            <FormItem label="发管">
              <Select v-model="search.tubeStatus" style="min-width: 95px;" :clearable="true">
                <Option v-for="item in tubeStatusList" :value="item.value" v-bind:key="item.value">{{item.label}}</Option>
              </Select>
            </FormItem>
          </Col>
          -->
          <Col>
            <FormItem label="拒检">
              <Select v-model="search.rejectStatus" style="min-width: 80px;" :clearable="true">
                <Option v-for="item in rejectStatusList" :value="item.value" v-bind:key="item.value">{{item.label}}</Option>
              </Select>
            </FormItem>
          </Col>
          <Col>
            <FormItem label="抽血">
              <Select v-model="search.checkStatus" style="min-width: 95px;" :clearable="true">
                <Option v-for="item in checkStatusList" :value="item.value" v-bind:key="item.value">{{item.label}}</Option>
              </Select>
            </FormItem>
          </Col>
          <Col>
            <FormItem label="抽血加项" :label-width="75">
              <Select v-model="search.optionsStatus" style="min-width: 80px;" :clearable="true">
                <Option v-for="item in optionsStatusList" :value="item.value" v-bind:key="item.value">{{item.label}}</Option>
              </Select>
            </FormItem>
          </Col>
          <Col>
            <FormItem label="数据">
              <Select v-model="search.dataStatus" style="min-width: 80px;" :clearable="true">
                <Option v-for="item in dataStatusList" :value="item.value" v-bind:key="item.value">{{item.label}}</Option>
              </Select>
            </FormItem>
          </Col>
          <Col>
            <FormItem label="异常">
              <Select v-model="search.errorStatus" :clearable="true">
                <Option v-for="item in errorStatusList" :value="item.value" v-bind:key="item.value">{{item.label}}</Option>
              </Select>
            </FormItem>
          </Col>
          <Col>
            <FormItem label="状态">
              <Select v-model="search.inspectStatus" style="min-width: 110px;" :clearable="true">
                <Option v-for="item in inspectStatusList" :value="item.value" v-bind:key="item.value">{{item.label}}</Option>
              </Select>
            </FormItem>
          </Col>
          <Col>
            <FormItem label="抽血日期" :label-width="75">
              <DatePicker style="width:114px ;" type="date" :editable="false" placeholder="起始日期" format="yyyy-MM-dd" v-model="search.startDate"  @on-change="changestart"/>
              <DatePicker style="width:114px ;" type="date" :editable="false" placeholder="结束日期" format="yyyy-MM-dd" v-model="search.endDate" @on-change="changeend"/>
            </FormItem>
          </Col>
          <Col><div style="display:flex;">&nbsp;&nbsp;<Button type="primary" @click="query">查询</Button></div></Col>
        </Row>
      </Form>
    </div>

    <Row>
      <div style="margin-top: 5px;width: 100%;">
        <div style="float: left;">
          <Button size="small" style="margin-left: 5px;" @click="batchPush" type="primary">全部推送</Button>
          <Button size="small" style="margin-left: 5px;" @click="batchPull" type="primary">全部拉取</Button>
          <Button size="small" style="margin-left: 5px;" @click="batchCancel" type="primary">全部取消</Button>
          <Button size="small" style="margin-left: 5px;" @click="batchClear" type="primary">全部清空</Button>
        </div>

        <div style="float: right;margin-right: 15px;">
          <Button size="small" style="margin-left: 5px;"  @click="batchBloodDraw()" type="default">一键抽血</Button>
          <Button size="small" style="margin-left: 5px;"  @click="batchCancelBloodDraw()" type="error">一键取消抽血</Button>
          <Button size="small" style="margin-left: 5px;"  @click="batchReject()" type="default">一键拒检</Button>
          <Button size="small" style="margin-left: 5px;"  @click="batchCancelReject()" type="error">一键取消拒检</Button>
          <Button size="small" style="margin-left: 5px;"  @click="batchPrint()" type="default">打印报告</Button>
          <Button size="small" style="margin-left: 5px;" @click="importData()" type="default">导入检验</Button>
          <Button size="small" style="margin-left: 5px;" @click="batchExport" type="default">导出名单</Button>
          <Button size="small" style="margin-left: 5px;" @click="bloodTest()" type="default">导出健促血检</Button>
        </div>
      </div>
    </Row>

    <el-table :data="dataList" style="width: 100%;" :header-cell-style="{ background: '#f8f8f9', color: '#515a6e', 'text-align': 'center'}"
              :row-class-name="tableRowClassName" @row-click="selectrow" @selection-change="selectList"
              highlight-current-row highlight-selection-row row-key="id" :max-height="tableHeight">

      <el-table-column fixed="left" type="selection" width="25"/>
      <el-table-column fixed="left" align="center" prop="taskName" label="体检任务" min-width="230"/>
      <el-table-column fixed align="center" prop="barCode" label="条形码" min-width="130">
        <template slot-scope="{row}">
          <el-tag size="small" type="danger" disable-transitions v-if="row.status === 1">待审核生成</el-tag>
          <span v-if="row.status !== 1">{{ row.barCode }}</span>
        </template>
      </el-table-column>
      <el-table-column fixed align="center" prop="name" label="姓名" min-width="100"/>
      <el-table-column align="center" prop="idCard" label="证件号码" min-width="180"/>
      <el-table-column align="center" prop="phone" label="手机号码" min-width="130"/>
      <el-table-column align="center" prop="schoolName" label="学校" min-width="200"/>
      <el-table-column align="center" prop="gradeName" label="年级" show-overflow-tooltip  min-width="110"/>
      <el-table-column align="center" prop="classesName" label="班级" show-overflow-tooltip  min-width="150"/>
      <el-table-column align="center" prop="birthday" label="出生日期" min-width="110"/>
      <el-table-column align="center" prop="checkStatus" label="抽血" min-width="100">
        <template slot-scope="{row}">
          <el-tag size="small" :type="row.checkStatus === 2 ? 'warning' : row.checkStatus === 3 ? 'primary' : 'danger'" disable-transitions>
            {{  checkStatusList.filter(u => u.value === row.checkStatus)[0].label }}
          </el-tag>
        </template>
      </el-table-column>
      <el-table-column align="center" prop="rejectStatus" label="拒检" min-width="100">
        <template slot-scope="{row}">
          <el-tag size="small" :type="row.rejectStatus === 2 ? 'danger' : 'primary'" disable-transitions>
            {{ row.rejectStatus === 1 ? '未拒检' : row.rejectStatus === 2 ? '已拒检' : '' }}
          </el-tag>
        </template>
      </el-table-column>
      <el-table-column align="center" prop="optionsStatus" label="抽血加项" min-width="80">
        <template slot-scope="{row}">
          <el-tag size="small" :type="row.optionsStatus === 1 ? 'primary' : row.optionsStatus === 2 ? 'success' : ''" disable-transitions>
            {{ row.optionsStatus === 1 ? '无加项' : row.optionsStatus === 2 ? '有加项' : '' }}
          </el-tag>
        </template>
      </el-table-column>
      <el-table-column align="center" prop="drawBloodDate" label="抽血日期" min-width="120">
        <template slot-scope="{row}">
          <i class="el-icon-time" v-if="row.drawBloodDate"/><span style="margin-left: 5px">{{ row.drawBloodDate }}</span>
        </template>
      </el-table-column>
      <el-table-column align="center" prop="dataStatus" label="数据状态" min-width="80">
        <template slot-scope="{row}">
          <el-tag size="small" :type="row.dataStatus === 1 ? 'danger' : row.dataStatus === 2 ? 'warning' : 'primary'" disable-transitions>
            {{ row.dataStatus === 1 ? '无数据' : row.dataStatus === 2 ? '漏项' : row.dataStatus === 3 ? '已完整' : '' }}
          </el-tag>
        </template>
      </el-table-column>
      <el-table-column align="center" prop="inspectStatus" label="状态" show-overflow-tooltip min-width="110">
        <template slot-scope="{row}">
          <el-tag size="small" :type="row.inspectStatus === 2 ? 'success' : row.inspectStatus === 6  || row.inspectStatus ===  10 ? 'primary'
                                      : (row.inspectStatus === 7 || row.inspectStatus === 9) ? 'warning'
                                      : (row.inspectStatus === 3 || row.inspectStatus === 5 || row.inspectStatus === 8) ? 'danger'
                                      : 'info'" disable-transitions>
            {{  inspectStatusList.filter(u => u.value === row.inspectStatus)[0].label }}
          </el-tag>
        </template>
      </el-table-column>
      <el-table-column align="center" prop="reason" label="原因" min-width="150"/>
      <el-table-column align="center" prop="abnormal" label="异常" min-width="350"/>
      <el-table-column align="center" prop="remark" label="备注" min-width="300"/>
      <el-table-column align="center" prop="bloodTubeRemark" label="试管" min-width="100"/>
      <el-table-column align="center" prop="operator" label="最后操作人" min-width="150">
        <template #default="{ row }">
          <div>{{ row.operatorAccount }}</div>
          <div>{{ row.operator }}</div>
        </template>
      </el-table-column>
      <el-table-column align="center" prop="updateTime" label="更新时间" min-width="160"/>
      <el-table-column fixed="right" align="center" prop="operation" label="操作"  min-width="250">
        <template slot-scope="{row}">
          <el-button type="text" size="medium" @click="batchBloodDraw(row.barCode, row.name)" v-if="row.dataStatus === 1 && row.checkStatus != 3 && row.rejectStatus == 1">抽血</el-button>
          <el-button type="text" size="medium" style="color: red;" @click="batchCancelBloodDraw(row.barCode, row.name)" v-if="row.dataStatus === 1 && row.checkStatus != 1">取消抽血</el-button>
          <el-button type="text" size="medium" @click="batchReject(row.barCode, row.name)" v-if="row.dataStatus === 1 && row.checkStatus == 1 && row.rejectStatus == 1">拒检</el-button>
          <el-button type="text" size="medium" style="color: red;" @click="batchCancelReject(row.barCode, row.name)" v-if="row.dataStatus === 1 && row.rejectStatus == 2">取消拒检</el-button>
          <el-button type="text" size="medium" @click="detail(row)">详情</el-button>
          <el-button type="text" size="medium" @click="inspect(row)" v-if="row.dataStatus > 1">检验</el-button>
          <el-button type="text" size="medium" @click="push(row)" v-if="row.checkStatus !== 1 && row.dataStatus !== 3">推送</el-button>
          <el-button type="text" size="medium" style="color: red;" @click="cancel(row)" v-if="row.inspectStatus === 2 || row.inspectStatus === 5">取消</el-button>
          <el-button type="text" size="medium" @click="pull(row)" v-if="row.checkStatus !== 1">拉取</el-button>
          <el-button type="text" size="medium" style="color: red;" @click="clear(row)" v-if="row.dataStatus > 1">清空</el-button>
          <el-button type="text" size="medium" @click="print(row)" v-if="row.checkStatus !== 1 && row.dataStatus > 1">打印</el-button>
        </template>
      </el-table-column>
    </el-table>

    <Page :total="pageList.total" :current="pageList.currentPage" :page-size="pageList.pageSize"
          show-elevator show-sizer show-total @on-change="chagecurrent"
          :page-size-opts="[10, 30, 50, 100]"
          @on-page-size-change="chagepagesize" style="margin-top:10px;"/>

    <el-dialog :title="inspectTitle" :visible.sync="dialogTableVisible" :fullscreen="false" :destroy-on-close="true" width="80%">
      <el-table :data="inspectList" stripe style="width: 100%;" tooltip-effect="dark" :header-cell-style="{ background:'#f8f8f9',color:'#515a6e','text-align':'center'}"
                highlight-current-row highlight-selection-row row-key="id" :max-height="tableHeight">

        <el-table-column fixed align="center" prop="name" label="姓名" min-width="90"/>
        <el-table-column fixed align="center" prop="groupName" label="分组名称" min-width="130"/>
        <el-table-column fixed align="center" prop="itemName" label="项目明细" min-width="130"/>
        <el-table-column fixed align="center" prop="itemValue" label="检查结果" min-width="70"/>
        <el-table-column align="center" prop="unit" label="单位" min-width="60"/>
        <el-table-column align="center" prop="notice" label="提示" min-width="40"/>
        <el-table-column align="center" prop="ranges" label="参考值" min-width="100"/>
        <el-table-column align="center" prop="submitter" label="检验人"/>
        <el-table-column align="center" prop="auditor" label="审核人"/>
        <el-table-column align="center" prop="reportDate" label="报告时间" min-width="120"/>
        <el-table-column align="center" prop="sources" label="来源">
          <template slot-scope="{row}">{{ row.sources===1?'拉取':row.sources===2?'导入':row.sources===3?'手动修改':''}}</template>
        </el-table-column>
        <el-table-column align="center" prop="operator" label="操作人" min-width="80"/>
        <el-table-column align="center" prop="createTime" label="操作时间" min-width="120"/>
      </el-table>
    </el-dialog>

    <Modal v-model="editWindow" width="50%" :title="windowTitle" :styles="{'top':'60px'}" :mask-closable="false" footer-hide>
      <InspectOrderPageEdit ref="edit" :style="{'overflow-y': 'auto'}"/>
    </Modal>

    <el-dialog :title="importTitle" :visible.sync="importWindow" width="400px" custom-class="my-dialog"
               :destroy-on-close="true" :close-on-click-modal="false" :close-on-press-escape="false">
      <el-upload ref="refUpload" action="#" :limit="1" class="upload-demo" drag multiple :auto-upload="false"
                 :on-change="handleChange" :on-remove="handleRemove" :file-list="fileList">
        <i class="el-icon-upload"></i>
        <div class="el-upload__text">将文件拖到此处，或<em>点击上传</em></div>
      </el-upload>
      <div><a @click.stop="template()">文件模版</a></div>

      <span slot="footer" class="dialog-footer">
          <el-button  @click="handleCancle">取 消</el-button>
          <el-button type="primary" @click="handleUpload" :disabled="importDisabled">确 定</el-button>
        </span>
    </el-dialog>

    <a id="printLis" v-print="printLisContent" v-show="false">打印</a>
    <span v-show="false">
     <printInspectOrder ref="printInspectOrder" :printData="printData"/>
    </span>

  </Content>
</template>
<script>

import {
  _page,
  _push,
  _pull,
  _cancel,
  _clear,
  _print,
  _batchPush,
  _batchPull,
  _batchCancel,
  _batchClear,
  _batchPrint,
  _template,
  _upload,
  _export,
  _bloodTest,
  _inspect,
  _bloodDraw,
  _cancelBloodDraw,
  _reject,
  _cancelReject,
} from "@/services/screening/inspectOrderPage.js";
import {_gradesList, _classesList} from "@/services/studentManage/studentManage";
import InspectOrderPageEdit from "./InspectOrderPageEdit";
import {mixins} from "@/mixins";
import {enums} from "@/services/enums";
import printInspectOrder from "./printInspectOrder.vue"

export default {
  name: "InspectOrder",
  mixins: [mixins],
  components: {
    printInspectOrder,
    InspectOrderPageEdit
  },
  computed: {

  },
  data() {
    return {
      tableHeight: 0,
      currentRowIndex: null,
      search: {
        barCode:"",
        taskId:"",
        schoolId:"",
        gradeId:"",
        classesId:"",
        name:"",
        idCard:"",
        // checkStatus:3,
        checkStatus:"",
        optionsStatus:"",
        tubeStatus:"",
        dataStatus:"",
        inspectStatus:"",
        errorStatus:"",
        startDate:"",
        endDate:"",
        barCodes:"",
      },
      inspectTitle:"检验详情",
      dialogTableVisible: false,
      inspectList: [],
      printData:[],
      barCodeList:[],
      enums:enums,
      editWindow:false,
      windowTitle:"详情",
      importWindow:false,
      importDisabled:false,
      importTitle:"",
      gradeList:[],
      classesList:[],
      fileList:[],
      printLisContent:{
        id:"printLisPage",
        preview:false,
        previewTitle:'  ',
        popTitle:'  ',
        extraHead:'<meta http-equiv="Content-Language" content="zh-cn"/>',
        previewBeforeOpenCallback(){
        },
        previewOpenCallback(){
        },
        beforeOpenCallback(vue){
        },
        openCallback(vue){
        },
        closeCallback(){
        },
        clickMounted(vue){
        }
      },
      checkStatusList:[
        {label: '全部', value: ''},
        {label: '未抽血', value: 1},
        {label: '部分抽血', value: 2},
        {label: '已抽血', value: 3},
      ],
      rejectStatusList:[
        {label: '全部', value: ''},
        {label: '未拒检', value: 1},
        {label: '已拒检', value: 2},
      ],
      tubeStatusList:[
        {label: '全部', value: ''},
        {label: '未发管', value: 1},
        {label: '已发管', value: 2},
      ],
      optionsStatusList:[
        {label: '全部', value: ''},
        {label: '无', value: 1},
        {label: '有', value: 2},
      ],
      dataStatusList:[
        {label: '全部', value: ''},
        {label: '无数据', value: 1},
        {label: '漏项', value: 2},
        {label: '已完整', value: 3},
      ],
      errorStatusList:[
        {label: '全部', value: ''},
        {label: '无异常', value: 1},
        {label: '有异常', value: 2},
      ],
      inspectStatusList:[
        {label: '待推送', value: 1},
        {label: '推送成功', value: 2},
        {label: '推送失败', value: 3},
        {label: '取消成功', value: 4},
        {label: '取消失败', value: 5},
        {label: '拉取成功', value: 6},
        {label: '拉取不完整', value: 7},
        {label: '拉取失败', value: 8},
        {label: '导入不完整', value: 9},
        {label: '导入成功', value: 10},
      ],
      dataList: [],
      pageList: {
        currentPage: 1,
        pageSize: 10,
        total: 0
      },
    };
  },
  created(){
    this.setDynamicHeight();
    window.addEventListener('resize', this.setDynamicHeight);
  },
  mounted() {
    if (this.$userSession.checkInstitutionId()) {
      this.handleDataList();
      this.applyTaskList();
      this.applySchoolsList();
      this.applyInspectOrganizeList();
    }
  },
  methods: {
    setDynamicHeight() {
      const height = window.innerHeight || document.documentElement.clientHeight;
      this.tableHeight = `${height - 335}px`;
    },
    changeSchool(schoolId) {
      if (!schoolId) {
        this.gradeList = [];
        this.classesList = [];
        this.search.gradeId = "";
        this.search.classesId = "";
        return;
      }
      _gradesList({schoolId: schoolId}).then(res => {
        this.search.schoolId = schoolId;
        this.search.gradeId = "";
        this.search.classesId = "";
        if (res.errcode === 1 && res.data) {
          this.gradeList = res.data;
        } else {
          this.gradeList = []
        }
      })
    },
    changeGrade(gradeId) {
      if (!gradeId) {
        this.classesList = [];
        this.search.classesId = "";
        return;
      }
      _classesList({schoolId: this.search.schoolId, gradeId: gradeId}).then(res => {
        this.search.gradeId = gradeId;
        this.search.classesId = "";
        if (res.errcode === 1 && res.data) {
          this.classesList = res.data;
        } else {
          this.classesList = []
        }
      })
    },
    push(row) {
      if(row.checkStatus === 1){
        this.$message.warning("未抽血不可推送");
        return;
      }
      if (row && row.id) {
        this.$confirm('确认要推送' + row.name + '检验吗?', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          dangerouslyUseHTMLString: true,
          type: 'warning'
        }).then(() => {
          _push({id: row.id}).then(res => {
            if (res.errcode === 1) {
              this.handleDataList();
              this.$message.success('推送成功');
            } else {
              this.$message.error(res.errmsg);
            }
          }).catch(() => {});
        }).catch(() => {
        });
      }
    },
    pull(row) {
      if(row.checkStatus === 1){
        this.$message.warning("未抽血不可拉取");
        return;
      }
      if (row && row.id) {
        _pull({id: row.id}).then(res => {
          if (res.errcode === 1) {
            this.$message.success('拉取完成');
            this.handleDataList();
          } else {
            this.$message.error(res.errmsg);
          }
        }).catch(() => {});
      }
    },
    clear(row){
      if(row.dataStatus === 1){
        this.$message.warning("无数据不可清空");
        return;
      }
      if (row && row.id) {
        _clear({id: row.id}).then(res => {
          if (res.errcode === 1) {
            this.$message.success('清空完成');
            this.handleDataList();
          } else {
            this.$message.error(res.errmsg);
          }
        }).catch(() => {});
      }
    },
    cancel(row) {
      if (row && row.id) {
        this.$confirm('确认要取消' + row.name + '检验吗?', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          dangerouslyUseHTMLString: true,
          type: 'warning'
        }).then(() => {
          _cancel({id: row.id}).then(res => {
            if (res.errcode === 1) {
              this.$message.success('取消成功');
              this.handleDataList();
            } else {
              this.$message.error(res.errmsg);
            }
          }).catch(() => {});
        }).catch(() => {});
      }
    },
    print(row) {
      this.printData = [];
      if (!this.$userSession.checkInstitutionId()) {
        this.$message.warning('请先选择机构');
        return;
      }else if (row.inspectStatus !== 6 && row.inspectStatus !== 7 && row.inspectStatus !== 9 && row.inspectStatus !== 10) {
        this.$message.warning('请检查状态!');
        return;
      }

      _print({barCode:row.barCode}).then(res => {
        if (res.errcode !== 1) {
          this.$Message.error(res.errmsg);
          return;
        }
        this.printData.push(res.data);

        this.$nextTick(()=>{
          document.getElementById('printLis').click();
        })
      }).catch(error => {
        console.log("error", error)
      });
    },
    template() {
      _template().then(res => {}).catch(error => {});
    },
    batchExport() {
      if (!this.$userSession.checkInstitutionId()) {
        this.$message.warning('请先选择机构');
        return;
      /*}else if (!this.search.taskId) {
        this.$message.warning("请先选择体检任务！！");
        return;*/
      }
      if(this.barCodeList && this.barCodeList.length > 0){
        this.search.barCodes = this.barCodeList.toString();
      }else{
        this.search.barCodes = "";
      }

      _export(this.search).then(res => {}).catch(error => {});
    },
    bloodTest(){
      if (!this.$userSession.checkInstitutionId()) {
        this.$message.warning('请先选择机构');
        return;
      }else if (!this.search.taskId) {
        this.$message.warning("请先选择体检任务！！");
        return;
      }
      if(this.barCodeList && this.barCodeList.length > 0){
        this.search.barCodes = this.barCodeList.toString();
      }else{
        this.search.barCodes = "";
      }

      _bloodTest(this.search).then(res => {}).catch(error => {});
    },
    batchPush() {
      if (!this.$userSession.checkInstitutionId()) {
        this.$message.warning('请先选择机构');
        return;
      }else if (!this.search.taskId) {
        this.$message.warning('请先选择体检任务');
        return;
      }else if (this.pageList.total && this.pageList.total > 300 && !this.search.gradeId) {
        this.$message.warning("请先选择年级！！");
        return;
      }

      this.$confirm('<h3>是否确定批量推送?</h3>', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        dangerouslyUseHTMLString: true,
        type: 'warning'
      }).then(() => {
        if(this.barCodeList && this.barCodeList.length > 0){
          this.search.barCodes = this.barCodeList.toString();
        }else{
          this.search.barCodes = "";
        }
        this.search.dataStatus = !this.search.dataStatus ? '' : this.search.dataStatus;
        // this.search.checkStatus = !this.search.checkStatus ? 3 : this.search.checkStatus;
        this.search.checkStatus = !this.search.checkStatus ? "" : this.search.checkStatus;
        this.search.inspectStatus = !this.search.inspectStatus ? '' : this.search.inspectStatus;
        this.search.optionsStatus = !this.search.optionsStatus ? '' : this.search.optionsStatus;
        this.search.tubeStatus = !this.search.tubeStatus ? '' : this.search.tubeStatus;
        this.search.errorStatus = !this.search.errorStatus ? '' : this.search.errorStatus;

        _batchPush(this.search).then(res => {
          if (res && res.errcode && res.errcode === 1) {
            this.handleDataList();
            if(res.data){
              this.$message.warning(res.data)
            }else{
              this.$message.success("全部推送成功")
            }
          } else {
            this.$Message.error(res.errmsg);
          }
        }).catch(() => {});
      }).catch(() => {});

    },
    batchPull() {
      if (!this.$userSession.checkInstitutionId()) {
        this.$message.warning('请先选择机构');
        return;
      }else if (!this.search.taskId) {
        this.$message.warning("请先选择体检任务！！");
        return;
      }

      this.$confirm('<h3>是否确定批量拉取?</h3>', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        dangerouslyUseHTMLString: true,
        type: 'warning'
      }).then(() => {
        if(this.barCodeList && this.barCodeList.length > 0){
          this.search.barCodes = this.barCodeList.toString();
        }else{
          this.search.barCodes = "";
        }
        this.search.dataStatus = !this.search.dataStatus ? '' : this.search.dataStatus;
        // this.search.checkStatus = !this.search.checkStatus ? 3 : this.search.checkStatus;
        this.search.checkStatus = !this.search.checkStatus ? "" : this.search.checkStatus;
        this.search.inspectStatus = !this.search.inspectStatus ? '' : this.search.inspectStatus;
        this.search.optionsStatus = !this.search.optionsStatus ? '' : this.search.optionsStatus;
        this.search.tubeStatus = !this.search.tubeStatus ? '' : this.search.tubeStatus;
        this.search.errorStatus = !this.search.errorStatus ? '' : this.search.errorStatus;

        _batchPull(this.search).then(res => {
          if (res && res.errcode && res.errcode == 1) {
            this.handleDataList();
            if(res.data){
              this.$message.warning(res.data)
            }else{
              this.$message.success("全部拉取成功")
            }
          } else {
            this.$Message.error(res.errmsg);
          }
        }).catch(() => {});
      }).catch(() => {});
    },
    batchCancel() {
      if (!this.$userSession.checkInstitutionId()) {
        this.$message.warning('请先选择机构');
        return;
      }else if (!this.search.gradeId) {
        this.$message.warning("请先选择年级！！");
        return;
      }

      this.$confirm('<h3>是否确定批量取消?</h3>', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        dangerouslyUseHTMLString: true,
        type: 'warning'
      }).then(() => {
        if(this.barCodeList && this.barCodeList.length > 0){
          this.search.barCodes = this.barCodeList.toString();
        }else{
          this.search.barCodes = "";
        }
        this.search.dataStatus = !this.search.dataStatus ? '' : this.search.dataStatus;
        // this.search.checkStatus = !this.search.checkStatus ? 3 : this.search.checkStatus;
        this.search.checkStatus = !this.search.checkStatus ? "" : this.search.checkStatus;
        this.search.inspectStatus = !this.search.inspectStatus ? '' : this.search.inspectStatus;
        this.search.optionsStatus = !this.search.optionsStatus ? '' : this.search.optionsStatus;
        this.search.tubeStatus = !this.search.tubeStatus ? '' : this.search.tubeStatus;
        this.search.errorStatus = !this.search.errorStatus ? '' : this.search.errorStatus;

        _batchCancel(this.search).then(res => {
          if (res && res.errcode && res.errcode === 1) {
            this.handleDataList();
            if(res.data){
              this.$message.warning(res.data)
            }else{
              this.$message.success("全部取消成功")
            }
          } else {
            this.$Message.error(res.errmsg);
          }
        }).catch(() => {});
      }).catch(() => {});
    },
    batchClear() {
      if (!this.$userSession.checkInstitutionId()) {
        this.$message.warning('请先选择机构');
        return;
      }else if (!this.search.taskId) {
        this.$message.warning("请先选择体检任务！！");
        return;
      }

      this.$confirm('<h3>是否确定批量清空?</h3>', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        dangerouslyUseHTMLString: true,
        type: 'warning'
      }).then(() => {
        if(this.barCodeList && this.barCodeList.length > 0){
          this.search.barCodes = this.barCodeList.toString();
        }else{
          this.search.barCodes = "";
        }
        this.search.dataStatus = !this.search.dataStatus ? '' : this.search.dataStatus;
        this.search.checkStatus = !this.search.checkStatus ? "" : this.search.checkStatus;
        this.search.inspectStatus = !this.search.inspectStatus ? '' : this.search.inspectStatus;
        this.search.optionsStatus = !this.search.optionsStatus ? '' : this.search.optionsStatus;
        this.search.tubeStatus = !this.search.tubeStatus ? '' : this.search.tubeStatus;
        this.search.errorStatus = !this.search.errorStatus ? '' : this.search.errorStatus;

        _batchClear(this.search).then(res => {
          if (res && res.errcode && res.errcode === 1) {
            this.handleDataList();
            if(res.data){
              this.$message.warning(res.data)
            }else{
              this.$message.success("全部清空成功")
            }
          } else {
            this.$Message.error(res.errmsg);
          }
        }).catch(() => {});
      }).catch(() => {});
    },
    batchPrint() {
      if (!this.$userSession.checkInstitutionId()) {
        this.$message.warning('请先选择机构');
        return;
      }else if (this.search.checkStatus === 1) {
        this.$message.warning('未检查不能打印');
        return;
      }else if (this.search.inspectStatus && this.search.inspectStatus !== 6 && this.search.inspectStatus !== 7 && this.search.inspectStatus !== 9 && this.search.inspectStatus !== 10) {
        this.$message.warning('请检查状态!');
        return;
      }else if (!this.search.taskId) {
        this.$message.warning("请先选择体检任务！！");
        return;
      }
      this.printData = [];

      if(this.barCodeList && this.barCodeList.length > 0){
        this.search.barCodes = this.barCodeList.toString();
      }else{
        this.search.barCodes = "";
      }
      _batchPrint(this.search).then(res => {
        if (res.errcode !== 1) {
          this.$Message.error(res.errmsg);
          return;
        }
        this.printData = res.data;

        this.$nextTick(()=>{
          document.getElementById('printLis').click();
        })
      }).catch(error => {
        console.log("error", error)
      });
    },
    importData(){
      if (!this.$userSession.checkInstitutionId()) {
        this.$message.warning('请先选择机构');
        return;
      }
      this.fileList = [];
      this.importTitle = "导入检验数据";
      this.importWindow = true;
    },
    handleChange(file, fileList){
      if (!this.$userSession.checkInstitutionId()) {
        this.$message.warning('请先选择机构');
        return
      }
      this.fileList = fileList;
    },
    handleRemove(file, fileList) {
      this.fileList = fileList;
      this.$nextTick(() => {
        this.$refs.refUpload.clearFiles();
      });
    },
    handleCancle() {
      this.fileList = [];
      this.importWindow = false;
      this.importDisabled = false;
    },
    handleUpload(){
      if (!this.$userSession.checkInstitutionId()) {
        this.$message.warning('请先选择机构');
        return
      }else if(this.fileList && this.fileList.length === 0){
        this.$message.warning('请先选择需要上传的文件');
        return;
      }
      this.importDisabled = true;

      _upload({file: this.fileList[0].raw}).then(res => {
        if (res && res.errcode && res.errcode === 1) {
          this.fileList = [];
          this.importWindow = false;
          this.importDisabled = false;

          this.$message.success("上传成功")
          this.reload()
        } else if(res){
          this.importDisabled = false;
          this.$message({
            type: 'error',
            message: res.errmsg,
            duration: 3000,
            center: true
          });
        }
      }).catch(res=>{
        this.importDisabled = false;
        /*this.$message({
          type: 'error',
          message: "上传失败",
          duration: 3000,
          center: true
        });*/
      }).finally(() =>{
        this.importDisabled = false;
      })
    },
    query() {
      if (!this.$userSession.checkInstitutionId()) {
        this.$message.warning('请先选择机构');
        return;
      }

      this.pageList.currentPage = 1;
      this.handleDataList();
    },
    handleDataList() {

      _page({
        ...this.search,
        ...this.pageList,
      }).then(res => {
        this.dataList = res.data.records;
        this.pageList.total = res.data.total;
      }).catch(() => {});
    },
    detail(row) {
      this.editWindow = true;
      this.$refs["edit"].handleModal(row);
    },
    inspect(row){
      _inspect({barCode: row.barCode}).then(res => {
        if (res && res.errcode && res.errcode === 1){
          this.inspectList = res.data;
          this.dialogTableVisible = true;
          this.inspectTitle = "检验详情" + "(" + row.name + ":"+ + row.barCode + ")" + "    总数:" + res.data.length;
        } else {
          this.$message.error(res.errmsg)
        }
      })
    },
    batchBloodDraw(barCode, name){
      let params = {}
      if(barCode){
        params.barCode = barCode;
      }else{
        params = {...this.search}
      }

      let _this = this;
      this.$confirm('<h3>' + (barCode ? '是否确定抽血<span style="color: #f56c6c;margin-left: 5px;">' + name + '</span>' : '是否确定一键抽血') + '?</h3>', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        dangerouslyUseHTMLString: true,
        type: 'warning'
      }).then(() => {
        _bloodDraw(params).then(res => {
          if (res && res.errcode && res.errcode === 1){
            _this.handleDataList();
            _this.$message.success(barCode ? "抽血成功" : "一键抽血成功")
          } else {
            _this.$message.error(res.errmsg)
          }
        })
      }).catch(() => {});
    },
    batchCancelBloodDraw(barCode, name){
      let params = {}
      if(barCode){
        params.barCode = barCode;
      }else{
        params = {...this.search}
      }

      let _this = this;
      this.$confirm('<h3>' + (barCode ? '是否确定取消抽血<span style="color: #f56c6c;margin-left: 5px;">' + name + '</span>' : '是否确定一键取消抽血') + '?</h3>', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        dangerouslyUseHTMLString: true,
        type: 'warning'
      }).then(() => {
        _cancelBloodDraw(params).then(res => {
          if (res && res.errcode && res.errcode === 1){
            _this.handleDataList();
            _this.$message.success(barCode ? "取消抽血成功" : "一键取消抽血成功")
          } else {
            _this.$message.error(res.errmsg)
          }
        })
      }).catch(() => {});
    },
    batchReject(barCode, name){
      let params = {}
      if(barCode){
        params.barCode = barCode;
      }else{
        params = {...this.search}
      }

      let _this = this;
      this.$confirm('<h3>' + (barCode ? '是否确定拒检<span style="color: #f56c6c;margin-left: 5px;">' + name + '</span>' : '是否确定一键拒检') + '?</h3>', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        dangerouslyUseHTMLString: true,
        type: 'warning'
      }).then(() => {
        _reject(params).then(res => {
          if (res && res.errcode && res.errcode === 1){
            _this.handleDataList();
            _this.$message.success(barCode ? "拒检成功" : "一键拒检成功")
          } else {
            _this.$message.error(res.errmsg)
          }
        })
      }).catch(() => {});
    },
    batchCancelReject(barCode, name){
      let params = {}
      if(barCode){
        params.barCode = barCode;
      }else{
        params = {...this.search}
      }

      let _this = this;
      this.$confirm('<h3>' + (barCode ? '是否确定取消拒检<span style="color: #f56c6c;margin-left: 5px;">' + name + '</span>' : '是否确定一键取消拒检') + '?</h3>', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        dangerouslyUseHTMLString: true,
        type: 'warning'
      }).then(() => {
        _cancelReject(params).then(res => {
          if (res && res.errcode && res.errcode === 1){
            _this.handleDataList();
            _this.$message.success(barCode ? "取消拒检成功" : "一键取消拒检成功")
          } else {
            _this.$message.error(res.errmsg)
          }
        })
      }).catch(() => {});
    },
    tableRowClassName(row, rowIndex) {
      row.row.index = row.rowIndex;
      /*if (row.row.optionsStatus && row.row.optionsStatus === 2) {
        return 'warning-row';
      }*/

      if (this.currentRowIndex === row.rowIndex) {
        return "select-row";
      }else{
        return "";
      }
    },
    selectList(e) {
      this.barCodeList = [];
      e.forEach(item => {
        this.barCodeList.push(item.barCode)
      })
    },
    selectrow(e, index, event){
      this.currentRowIndex = e.index;
    },
    chagecurrent(e) {
      this.pageList.currentPage = e
      this.handleDataList()
    },
    chagepagesize(e) {
      this.pageList.pageSize = e
      this.handleDataList()
    },
    changestart(e) {
      this.search.startDate = e
    },
    changeend(e) {
      this.search.endDate = e
    },
    toInt(){
      if(this.search.barCode){
        this.search.barCode = (this.search.barCode + "").replace(/[^\d]+/g, '');
        this.search.barCode = (this.search.barCode + "").replace('.', '');
        this.search.barCode = (this.search.barCode + "").replace(/\./g, '');
        this.search.barCode = (this.search.barCode + "").replace(/\\./g, '');
        this.search.barCode = (this.search.barCode + "").replace('$#$', '');
      }
    }
  }
};
</script>
<style lang="postcss" scoped>
/deep/ .el-table__body tr.select-row>td.el-table__cell{background-color: #beffc5;color: #101010;}
/deep/ .el-table__body tr.warning-row>td.el-table__cell{background-color: #fdf5e6;color: #101010;}
/deep/ #searchForm .ivu-form-item {margin-bottom: 5px;vertical-align: top;zoom: 1;}
table thead th {background: #f5f5f5;padding: 10px;}
/deep/ .el-dialog__body {padding: 5px 20px;}
/deep/ .el-input__inner {height: 30px;line-height: 30px;}
/deep/ .el-input__icon{line-height: 30px;}
/deep/ .el-input--suffix .el-input__inner {padding-right: 0px;}
/deep/ .el-table .el-table__cell {padding: 10px 0;}

</style>
